<template>
  <div>
    <som-toast-group id="toastContainer" position="end">
      <som-toast v-for="toast in toasts" :key="toast.id" :headline="toast.headline" :color="toast.color">
        {{ toast.message }}
      </som-toast>
    </som-toast-group>
    <slot />
  </div>
</template>

<script setup>
import { provide, ref } from 'vue';

const toasts = ref([]);

let idCounter = 0;
function showToast({ headline = 'Notice', message = '', color = 'info', duration = 3000 }) {
  // eslint-disable-next-line no-plusplus
  const id = ++idCounter;
  const toast = { id, headline, message, color };
  toasts.value.push(toast);

  setTimeout(() => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }, duration);
}

provide('showToast', showToast);
</script>
